module.exports = __webpack_public_path__ + "static/img/qrcode-bg.bf49dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/scan1/qrcode-bg.png
// module id = Y9AS
// module chunks = 1